import { render, staticRenderFns } from "./BadgePostPremium.vue?vue&type=template&id=115ee9df&scoped=true&"
import script from "./BadgePostPremium.vue?vue&type=script&lang=js&"
export * from "./BadgePostPremium.vue?vue&type=script&lang=js&"
import style0 from "./BadgePostPremium.vue?vue&type=style&index=0&id=115ee9df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115ee9df",
  null
  
)

component.options.__file = "BadgePostPremium.vue"
export default component.exports